<template>
  <ProductRoleMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
